import script from "./GeneralSectionsListComponentForJob.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralSectionsListComponentForJob.vue?vue&type=script&setup=true&lang=js"

import "./GeneralSectionsListComponentForJob.vue?vue&type=style&index=0&id=5b75e522&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b75e522"]])

export default __exports__